import React from 'react';
export const Header = () => {
  return <header className="my-8 px-4 md:px-0" data-id="element-101">
      <h1 className="text-3xl md:text-5xl font-bold mb-6 leading-tight text-center md:text-left" data-id="element-102">
        5 Proven Natural Ingredients That Actually Help Men Burn Fat, Pack On
        Muscle, and Increase Their Manliness
      </h1>
      <h2 className="text-xl md:text-3xl mb-8 font-semibold text-center md:text-left" data-id="element-103">
        You Won't Find Any Of These At GNC, Amazon, or the Gas Station
      </h2>
      <h3 className="text-lg md:text-2xl mb-12 italic text-center md:text-left" data-id="element-104">
        Harvard-trained endocrinologist reveals the powerful natural compounds
        that warriors across the world have been using for thousands of years to
        build muscle and stay lean
      </h3>
    </header>;
};